import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import DatasourceBaseTextFields from "../Datasources/DatasourceBaseTextFields.jsx";

const DatasourceFasterForwardElements = (props) => {

    const Fields = [
        {Identifier:"UserName", Translation:Translate("Username"), Required:true},
        {Identifier:"Secret", Translation:Translate("Secret"), Required:true},
        {Identifier:"DataBase", Translation:Translate("Subdomain"), Required:true},
        {Identifier:"OrganisationNumber", Translation:Translate("Organization number"), Required:true},
        {Identifier:"DatasourceVersion", Translation:"", Required:true, StaticValue:"2"}
    ]
    
    return (<DatasourceBaseTextFields SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} Fields={Fields} OnSetReady={props.OnSetReady}/>)

}

DatasourceFasterForwardElements.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceFasterForwardElements